import type { AuthenticateBuilderSessionPayload } from '~/composables/api/internal/builder-session/useFetchBuilderSession'
import type { AuthenticateBrowserSessionPayload, BrowserSessionData, CompleteBrowserSessionPayload } from '~/composables/api/internal/browser-session/useFetchBrowserSession'

import { BROWSER_SESSION } from '~/types'

export const useBrowserSessionStore = defineStore('browserSession', () => {
  const {
    checkAuth,
    sessionData,
    authenticateSession,
    isAuthenticated,
    authenticationRequestError,
    cancelSession,
    fetchCurrentSession,
    redirectToHandler,
  } = useApiSessionManagement<
    BrowserSessionData,
    AuthenticateBrowserSessionPayload & AuthenticateBuilderSessionPayload
  >(BROWSER_SESSION)

  // completion
  const {
    state: completionRequestData,
    execute: complete,
    error: completionRequestError,
  } = useMutateBrowserSession.complete()

  whenever(completionRequestError, (error: any) => {
    // If failed with status conflict, try to fetch current session
    // as it is probably already completed
    if (error.response?.status === 409)
      fetchCurrentSession()
    else
      throw error
  })

  whenever(completionRequestData, () => {
    sessionData.value = completionRequestData.value!
  })

  const completeSession = (payload: CompleteBrowserSessionPayload) => complete(0, { payload })

  return {
    checkAuth,
    sessionData,
    authenticateSession,
    isAuthenticated,
    authenticationRequestError,
    completeSession,
    cancelSession,
    redirectToHandler,
  }
})
